import React, { useEffect } from "react";
import {
  useSettingsFormState,
  useSettingsLoading,
} from "../store/settings-store";
import { SettingsFooter } from "../components/SettingsFooter";
import { PasswordSection } from "./sections/PasswordSection";
import { DeviceSection } from "./sections/DeviceSection";
import { useSecurity } from "./hooks/use-security";

export const SecurityTab: React.FC = () => {
  const {
    setHasUnsavedChanges,
    markAsSaved,
    registerDraftReset,
    unregisterDraftReset,
  } = useSettingsFormState("security");
  const { isLoading } = useSettingsLoading("security");

  // Security hook - handles all state and actions
  const {
    hasPasswordChanges,
    isPasswordFormValid,
    handleChangePassword,
    resetPasswordForm,
  } = useSecurity();

  // Track changes
  useEffect(() => {
    setHasUnsavedChanges(hasPasswordChanges);
  }, [hasPasswordChanges, setHasUnsavedChanges]);

  // Register draft resetter for global clear
  useEffect(() => {
    registerDraftReset(resetPasswordForm);
    return () => unregisterDraftReset(resetPasswordForm);
  }, [registerDraftReset, unregisterDraftReset, resetPasswordForm]);

  const handleSave = async () => {
    if (isPasswordFormValid) {
      await handleChangePassword();
      markAsSaved();
    }
  };

  const handleCancel = () => {
    resetPasswordForm();
    markAsSaved();
  };

  return (
    <div className="flex flex-col gap-8">
      {/* Desktop: Side by side layout */}
      <div className="hidden lg:grid lg:grid-cols-2 lg:gap-8">
        {/* Left: Password Change Form */}
        <PasswordSection />

        {/* Right: Where you're logged in */}
        <DeviceSection />
      </div>

      {/* Mobile: Stacked layout */}
      <div className="flex flex-col gap-8 lg:hidden">
        {/* Password Change Form */}
        <PasswordSection />

        {/* Where you're logged in */}
        <DeviceSection />
      </div>

      {/* Footer Actions */}
      <SettingsFooter
        onSave={handleSave}
        onCancel={handleCancel}
        isLoading={isLoading}
        disabled={!isPasswordFormValid}
      />
    </div>
  );
};
